import workspaces from '../workspaces.json';
import { getActiveProductLine } from './adapters/AdapterRegistry';
import { buildCanvasRoute, DEFAULT_LANDING_PATH } from './constants/routes';

const runtime = window.RUNTIME_CONFIG ?? {};
const env = runtime.UI_ENV || 'local';

const allRemotes = env === 'production' ? workspaces.production : workspaces.local;
const remoteIdFilter = (runtime.UI_WORKSPACE_REMOTE_IDS || '')
  .split(',')
  .map((id: string) => id.trim())
  .filter((id: string) => id.length > 0);
const workspacesConfig =
  remoteIdFilter.length > 0
    ? { remotes: allRemotes.remotes.filter(r => remoteIdFilter.includes(r.id)) }
    : allRemotes;

function resolveDefaultLandingPath(): string {
  const ukey = getActiveProductLine()?.landingCanvasUkey?.trim();
  if (ukey) return buildCanvasRoute(ukey);
  return DEFAULT_LANDING_PATH;
}

export const config = {
  env,
  baseUrl: runtime.UI_BASE_URL || '',
  redirectUri: runtime.UI_REDIRECT_URI || '',
  tenant: runtime.UI_TENANT || '',

  /**
   * PRD-050, DR-15: client-side allowlist of hostnames trusted for `chart_embed`
   * block iframes — defense-in-depth mirror of DESO's `DESO_EMBED_ALLOWED_HOSTS`.
   * Comma-separated, case-insensitive, whitespace-trimmed.
   */
  embedAllowedHosts: (runtime.UI_EMBED_ALLOWED_HOSTS || '')
    .split(',')
    .map((host: string) => host.trim().toLowerCase())
    .filter((host: string) => host.length > 0),

  // Workspace MFE remotes (DR-12) — common across all product lines.
  // Optional UI_WORKSPACE_REMOTE_IDS narrows the set for Path B Docker.
  workspacesConfig,

  /**
   * Post-login and root fallback route.
   * Prefer product-line `landingCanvasUkey` when set; otherwise code default.
   */
  get defaultLandingPath(): string {
    return resolveDefaultLandingPath();
  },
};
